export default "__VITE_ASSET__CHk3lZPl__"